export default __webpack_public_path__ + "static/media/affordable 1.86cc6403.png";